import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { log404Error } from '../services/errorLogger';

const NotFoundPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Log 404 error with the attempted path
    log404Error(location.pathname + location.search);
  }, [location]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-xl shadow-lg p-8">
          {/* Sad Whale */}
          <img
            src="/whale-sad.png"
            alt="Page not found"
            className="w-40 h-40 mx-auto mb-6 object-contain"
          />

          <h1 className="text-6xl font-bold text-gray-300 mb-2">404</h1>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="flex flex-col gap-3">
            <Link
              to="/"
              className="w-full py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg transition-colors text-center"
            >
              Go to Home
            </Link>
            <Link
              to="/app"
              className="w-full py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors text-center"
            >
              Go to App
            </Link>
          </div>
        </div>

        <p className="mt-6 text-sm text-gray-400">
          Need help? <Link to="/contact" className="text-blue-500 hover:underline">Contact us</Link>
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
